import { useState } from 'react';

import { useServerClient } from '../useServerClient'

import { routeTypes } from '../useSystemRoutes';

export const authTargetTypes = {
    admin: "administrator",
    retail: "retailer",
    workstation: "worker",
    customer: "customer",
    member: "member",
    driver: "driver",
}

export const authTargetSystemRouteTypes = {
    [authTargetTypes.admin]: routeTypes.admin,
    [authTargetTypes.retail]: routeTypes.retail,
    [authTargetTypes.workstation]: routeTypes.workstation,
    [authTargetTypes.customer]: routeTypes.customer,
    [authTargetTypes.member]: routeTypes.member,
    [authTargetTypes.driver]: routeTypes.driver,
}

export function useAuth(authTarget) {

    const { makeCall } = useServerClient();
    const [target, setTarget] = useState(authTarget)
    const [isLoading, setIsLoading] = useState(false)

    const endpointAuth = "auth/";

    const authLogin = async ({ username, password }) => {

        setIsLoading(true);

        try {

            const url = `${endpointAuth}token`;

            let _authTarget = authTarget

            const postData = {
                scope: {
                    target: _authTarget
                },
                payload: {
                    username,
                    password
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const authLoginByApiKey = async ({ apiKey, hashToken }) => {

        setIsLoading(true);

        try {

            const url = `${endpointAuth}token`;

            let _authTarget = authTarget

            const postData = {
                scope: {
                    target: _authTarget
                },
                payload: {
                    api_key: apiKey,
                    hash_token: hashToken
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const changePassword = async ({ current, password, confirm }) => {

        setIsLoading(true);

        try {

            const url = `${endpointAuth}`;

            const postData = {
                scope: {
                    target: "change_password"
                },
                payload: {
                    auth: {
                        current_password: current,
                        new_password: password,
                        confirm_password: confirm
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    return {
        isLoading,
        authTargetTypes,
        authLogin,
        authLoginByApiKey,
        changePassword
    }
}